<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header title="Course Enrollments" icon="fa-chalkboard-teacher"/>

<!--            <b-message type="is-warning" class="mt-6">-->
<!--                <div class="columns is-gapless mt-4">-->
<!--                    <div class="column is-narrow"><i class="fas fa-question-circle fa-fw mr-3 has-text-warning"></i></div>-->
<!--                    <div class="column">-->
<!--                        <div class="is-size-6 has-text-weight-bold">Looking for Your Course Enrollments?</div>-->

<!--                        <div class="is-size-6 mt-3">We are upgrading the my247ed.com site. If you’re looking for your course enrollments or the legacy course catalog, please visit the legacy site button below to access your courses as usual. If you have any questions feel free to contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.</div>-->
<!--                        <div class="mb-4 mt-5">-->
<!--                            <b-button tag="a" type="is-primary" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash">Visit Legacy Site<i class="fad fa-arrow-up-right-from-square ml-3"></i></b-button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </b-message>-->

            <div class="columns mt-6">
                <div class="column is-9-fullhd">
                    <p class="has-text-white" v-if="!enrollments || !classicEnrollments"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading your enrollments...</p>
                    <div v-else>
                        <div v-if="activeEnrollments.length === 0 && classicEnrollments.length === 0">
                            <p class="has-text-white"><i class="far fa-info-circle fa-fw mr-3"></i>You currently have no active Course Enrollments.<br><i class="far fa-fw mr-3"></i><span class="has-text-weight-bold">Browse the available courses in the Online Course Catalog to get started.</span></p>
                        </div>
                        <div class="columns" v-if="activeEnrollments.length">
                            <div class="column">
                                <enrollment :enrollment="enroll" v-for="enroll in activeEnrollments" class="mb-5"/>
                            </div>
                        </div>
                        <div class="columns" v-if="classicEnrollments.length">
                            <div class="column">
                                <classic-enrollment :enrollment="enroll" v-for="enroll in classicEnrollments" class="mb-5"/>
                            </div>
                        </div>

                        <section v-if="completedEnrollments.length !== 0" class="pt-4">
                            <h2 class="mb-1 mt-6 mb-6 has-text-white"><i class="fad fa-check-to-slot fa-fw mr-3"></i>Completed Courses</h2>
                            <enrollment :enrollment="enroll" v-for="enroll in completedEnrollments" class="mb-5"/>
                        </section>

                        <!--                        <b-tabs>-->
                        <!--                            <b-tab-item label="2022">-->

                        <!--                            </b-tab-item>-->

                        <!--                            <b-tab-item label="2021">-->

                        <!--                            </b-tab-item>-->

                        <!--                            <b-tab-item label="2020">-->

                        <!--                            </b-tab-item>-->
                        <!--                        </b-tabs>-->

                    </div>


                </div>
                <div class="column has-text-white has-text-right is-3-fullhd is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only">
                    <div class="mb-6 ">
                        <router-link :to="{name: 'course-catalog'}">
                            <b-button type="is-light" outlined><i class="fad fa-browsers mr-3"></i>Browse Available Courses</b-button>
                        </router-link>
                    </div>
                </div>
            </div>

        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import MainHeader from "../../components/framework/MainHeader";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import Enrollment from "../../components/Enrollment";

    import {mapActions, mapGetters} from "vuex";
    import ClassicEnrollment from "../../components/ClassicEnrollment.vue";

    export default {
        components: {ClassicEnrollment, Enrollment, Framework, SidePanelNav, MainHeader},
        data: function() {
            return {
                showCompleted: false
            };
        },
        computed: {
            ...mapGetters(['enrollments', 'classicEnrollments', 'currentUser']),
            activeEnrollments: function() {
                let enrollments = [];
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (!enrollment.completed_at) enrollments.push(enrollment);
                }

                enrollments.sort((a, b) => {
                    return new Date(b.started_at) - new Date(a.started_at);
                });

                return enrollments;
            },
            completedEnrollments: function() {
                let enrollments = [];
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (enrollment.completed_at) enrollments.push(enrollment);
                }

                enrollments.sort((a, b) => {
                    return new Date(b.completed_at) - new Date(a.completed_at);
                });

                return enrollments;
            }
        },
        methods: {
            ...mapActions(['getEnrollments'])
        },
        mounted() {
            this.getEnrollments();
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }
    }
</style>

<style lang="scss">

</style>
